export const _convertObjectToQuery = obj => {
  let query = '';
  for (let key in obj) {
    if (obj[key] !== undefined && obj[key] !== null) {
      if (Array.isArray(obj[key])) {
        obj[key].forEach(value => {
          if (value !== undefined && value !== null) {
            const encodedVal = encodeURIComponent(typeof value === 'string' ? value.trim() : value);
            if (query) {
              query += `&${key}=${encodedVal}`;
            } else {
              query += `${key}=${encodedVal}`;
            }
          }
        });
      } else {
        const encodedVal = encodeURIComponent(typeof obj[key] === 'string' ? obj[key].trim() : obj[key]);
        if (query) {
          query += `&${key}=${encodedVal}`;
        } else {
          query += `${key}=${encodedVal}`;
        }
      }
    }
  }
  return query;
};
export const checkPermission = (listPermissionOfUser ,  permissionId) =>{
  return listPermissionOfUser.includes(permissionId);
}

